export const TERMINAL = 'TERMINAL';
export const CUSTOMER = 'CUSTOMER';

export const LOCATION_TYPES = [CUSTOMER, TERMINAL];
